import { render } from "./NavigationBarTop.vue?vue&type=template&id=c636f20c&scoped=true"
import script from "./NavigationBarTop.vue?vue&type=script&lang=js"
export * from "./NavigationBarTop.vue?vue&type=script&lang=js"

import "./NavigationBarTop.vue?vue&type=style&index=0&id=c636f20c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c636f20c"]])

export default __exports__